import { render, staticRenderFns } from "./UserCardMessengers.vue?vue&type=template&id=007ca232&scoped=true&"
import script from "./UserCardMessengers.vue?vue&type=script&lang=ts&"
export * from "./UserCardMessengers.vue?vue&type=script&lang=ts&"
import style0 from "./UserCardMessengers.vue?vue&type=style&index=0&id=007ca232&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ca232",
  null
  
)

export default component.exports